import { Inject, Injectable } from "@angular/core";
import { ReplaySubject } from "rxjs";
import { RoleService } from '@roles/services/role.service';
import { MojoWellKnownNames } from '@common/constants/mojo-well-known-names';

/**
 * This service has a useResponsiveLayout$ property that returns true if the application should use responsive layout
 * 
 * Currently this is based on whether the app is launched from a small screen and whether the logged in user is an Occupant User
 */
@Injectable({
  providedIn: "root",
})
export class ShouldUseResponsiveLayoutService {

  readonly useResponsiveLayout$ = new ReplaySubject<boolean>(1);

  constructor(
    @Inject(Window) window: Window,
    private readonly roleService: RoleService) {
    const magicNumberMatchingIDServerLogInScreenBreakPointAndNotAnMdMediaQuery = 768;

    this.roleService.isInRoleAsync(MojoWellKnownNames.RoleNames.OccupantUser).subscribe(result => {
      this.useResponsiveLayout$.next(window.innerWidth < magicNumberMatchingIDServerLogInScreenBreakPointAndNotAnMdMediaQuery || result);
    });
  }
}